import { createContext } from 'react'
import { WidgetContextHolder } from '@typesApp/WidgetContextHolder'

export const WidgetContext = createContext<WidgetContextHolder>({})
